import React from 'react';
import SharedFooter from '../../../components/ui/SharedFooter';

const FooterSection = () => {
  return <SharedFooter hideSocialLinks={false} />;
};

export default FooterSection;